import React from 'react';
import { useSidebar } from '../../contexts/SidebarContext';
import { useTheme } from '../../contexts/ThemeContext';

interface SidebarProps {
    children?: React.ReactNode;
    collapsedContent?: React.ReactNode;
}

const Sidebar: React.FC<SidebarProps> = ({ children, collapsedContent }) => {
    const { isCollapsed, toggleSidebar } = useSidebar();
    const { darkMode } = useTheme();

    return (
        <aside 
            className={`${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border-r fixed left-0 top-14 bottom-0 flex flex-col transition-all duration-300 z-40 ${
                isCollapsed ? 'w-16' : 'w-64'
            }`}
        >
            <div className="flex-1 overflow-y-auto">
                {isCollapsed ? (
                    <div className="py-2">
                        {collapsedContent}
                    </div>
                ) : (
                    <div>
                        {children}
                    </div>
                )}
            </div>
            <div className={`p-2 border-t ${darkMode ? 'border-gray-700' : 'border-gray-200'} mt-auto`}>
                <button
                    onClick={toggleSidebar}
                    className={`w-full flex items-center justify-center p-2 rounded-lg transition-colors ${
                        darkMode 
                            ? 'text-gray-300 hover:bg-gray-700' 
                            : 'text-gray-600 hover:bg-gray-100'
                    }`}
                    title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
                >
                    <i className={`fa-solid ${isCollapsed ? 'fa-angles-right' : 'fa-angles-left'} text-sm`}></i>
                </button>
            </div>
        </aside>
    );
};

export default Sidebar;
